// src/lib/serviceLabel.ts
export function displayServiceName(raw: unknown) {
  const s = String(raw ?? "").trim();
  if (!s) return s;

  // "drink" 단독
  if (s === "drink") return "주류/음료";

  // "drink / ..." 형태
  if (s.startsWith("drink/")) return "주류/음료" + s.slice("drink".length);
  if (s.startsWith("drink /")) return "주류/음료" + s.slice("drink".length);

  // 혹시 "drink | ..." 같은 형태도 방어
  if (s.startsWith("drink ")) return "주류/음료" + s.slice("drink".length);

  return s;
}
